import { render, staticRenderFns } from "./TableCargoReclamoClienteComponent.vue?vue&type=template&id=22d1742f&"
import script from "./TableCargoReclamoClienteComponent.vue?vue&type=script&lang=js&"
export * from "./TableCargoReclamoClienteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports